import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=0382189e&scoped=true&"
var script = {}
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=0382189e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382189e",
  null
  
)

export default component.exports